<script lang="ts">
  import { getContext } from "svelte";
  import RadioCheckIndicator from "../../../common/RadioCheckIndicator.svelte";
  import Icon from "../../../../common/icons/Icon.svelte";
  import type {
    PlanDescription,
    PlanRecurringPeriod,
  } from "../../../../../app/store/store-plan";
  import {
    CREATE_NEW_ACCOUNT_CONTEXT_NAME,
    getPlanTierIcon,
  } from "../../utils";
  import type { CreateNewAccountContext } from "../../type";
  import {
    plansDataStore,
    getPlanBaseCost,
  } from "../../../../../app/store/store-plan";

  export let data: PlanDescription;
  export let selected: boolean;
  export let duration: PlanRecurringPeriod;

  const context: CreateNewAccountContext = getContext(
    CREATE_NEW_ACCOUNT_CONTEXT_NAME
  );
  let accountType = context.getAccountType();
  const planTier = data.value;
  let planCost: number = 0;

  function formatCurrency(value: number) {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

    return formatter.format(value).substring(1);
  }

  $: planData = $plansDataStore;
  $: isYearly = duration === "yearly";
  $: planData,
    duration,
    data,
    (planCost = getPlanBaseCost(accountType, planTier, duration));
</script>

<div class="plan-item" class:selected class:recommended={data.isRecommended}>
  <div class="absolute top-2 right-2">
    <RadioCheckIndicator active={selected} />
  </div>

  <div class="item-content">
    <div
      class="mb-5 flex flex-row items-center gap-2 text-dark-300 font-medium"
    >
      <div>
        <Icon icon={getPlanTierIcon(data.value)} size="20px" />
      </div>
      <div>{data.title}</div>
    </div>

    <div class="mb-11 flex flex-col gap-1.5">
      {#each data.features as feature}
        <div class="flex flex-row gap-2 items-start">
          <div class="h-5 w-2.5 flex flex-row items-center justify-center">
            {#if feature.enable}
              <Icon icon="blue-tick" width="9px" height="8px" />
            {:else}
              <Icon icon="red-cross" size="7px" />
            {/if}
          </div>
          <div class="text-dark-100" class:text-opacity-40={!feature.enable}>
            {feature.item}
          </div>
        </div>
      {/each}
    </div>

    <div class="text-[15px] pb-2.5">
      <span class="font-semibold text-dark-300">
        $ {formatCurrency(planCost)}
      </span>
      <span class="text-dark-50">{isYearly ? "/yr." : "/mth."}</span>
    </div>
  </div>

  <div class="recommended-content">Recommended</div>
</div>

<style lang="postcss">
  .plan-item {
    @apply relative p-0.5 rounded bg-white cursor-pointer;
    /* width: 200px; */
    min-width: 200px;
    box-shadow: 2px 2px 10px rgba(55, 84, 170, 0.12);
  }

  .plan-item.selected {
    background: linear-gradient(92.69deg, #3bc7ff 0%, #5f89ff 100%);
  }

  .item-content {
    @apply rounded-sm;
    padding: 18px 14px 0px 14px;
    background: white;
  }

  .recommended .item-content {
    @apply rounded-bl-none rounded-br-none;
  }

  .recommended-content {
    @apply hidden py-1 rounded-bl-sm rounded-br-sm;
    @apply text-center text-white text-[9px] font-semibold uppercase tracking-[2px];
  }

  .recommended .recommended-content {
    @apply block;
  }

  .recommended:not(.selected) .recommended-content {
    background: linear-gradient(90.7deg, #3bc7ff 0%, #5f89ff 100%);
  }
</style>
